import { tState } from "@src/Model/Model"
import { FREQUENCY_OPTIONS } from "@src/Portal/Monitoring/constants"
import { tProbelyScanFrequency } from "@src/types"
import React from "react"
import { useSelector } from "react-redux"

export const useFrequencyTabOptions = () => {
  const plans = useSelector((store: tState) => store.plans)

  const planFrequencies = plans.probelyScanFrequency
  // TODO channelFrequencies should be a list of all available frequencies for the channel and must be obtained from kita
  const channelFrequencies = planFrequencies

  const tabOptions = React.useMemo(
    () =>
      FREQUENCY_OPTIONS.map((option) => {
        const recurrence: tProbelyScanFrequency =
          option.label.toUpperCase() as tProbelyScanFrequency

        return {
          recurrence,
          id: option.value,
          title: option.label,
          isHidden: !channelFrequencies?.includes(recurrence),
          isDisabled: !planFrequencies?.includes(recurrence),
        }
      }),
    [channelFrequencies, planFrequencies],
  )

  return tabOptions
}
